import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M21.98,15.909v-.03c-.22-.98-3.01-3.75-5.99-3.75s-5.81,2.82-5.98,3.78a.213.213,0,0,0,0,.18c.16.95,2.94,3.73,5.9,3.77.03,0,.06.01.08.01a.277.277,0,0,0,.09-.01c2.97-.04,5.74-2.82,5.9-3.77a.277.277,0,0,0,.01-.09A.308.308,0,0,0,21.98,15.909Zm-5.99,2.53A2.44,2.44,0,1,1,18.44,16,2.443,2.443,0,0,1,15.99,18.439ZM17.25,16a1.255,1.255,0,1,1-2.51,0,1.255,1.255,0,0,1,2.51,0ZM6.68,20.619H14v1.5H6.68a3.758,3.758,0,0,1-3.75-3.75V5.639a3.751,3.751,0,0,1,3.75-3.75h7.88l5.76,5.75V11h-1.5V8.639H13.56V3.389H6.68a2.247,2.247,0,0,0-2.25,2.25v12.73A2.253,2.253,0,0,0,6.68,20.619Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentEyeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'documentEye'),
) as IconWithRender;

DocumentEyeIcon.displayName = 'DocumentEyeIcon';
DocumentEyeIcon.propTypes = Icon.propTypes;
DocumentEyeIcon.renderIcon = (props) => <DocumentEyeIcon {...props} />;
export default DocumentEyeIcon;
